import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { rgba } from 'foundations-components/transitional/utils/color';
import { useTheme } from 'foundations-theming/utils';
import { UITourPulserBorderShadow } from './UITourPulserElements';
import UITourPulserLayer from './UITourPulserLayer';
import UITourPulserOverlay from './UITourPulserOverlay';
import UITourPulserSpotlight from './UITourPulserSpotlight';
import { getAttachedElements } from '../utils/elementUtils';
import { usePulserContainer } from '../hooks/pulser';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const PULSER_BORDER_SHADOW_ID = 'pulser-border-shadow';
const POPOVER_DEFAULT_Z_INDEX = 1111;
const UITourPulserLegacy = ({
  attachTo,
  borderColor: borderColorProp,
  borderRadius = 3,
  borderSize = 3,
  enableBorder = true,
  enableOverlay = true,
  enablePulse: __enablePulse = true,
  pulserDistance = 6,
  pulserDuration = '2s',
  pulserOverlayColor: pulserOverlayColorProp,
  pulserPadding = 4,
  pulserZIndex = POPOVER_DEFAULT_Z_INDEX,
  target
}) => {
  const theme = useTheme();
  const borderColor = borderColorProp !== null && borderColorProp !== void 0 ? borderColorProp : theme.color['fill-accent-purple-default'];
  const pulserOverlayColor = pulserOverlayColorProp !== null && pulserOverlayColorProp !== void 0 ? pulserOverlayColorProp : rgba(theme.color['specialty-scrim'], 0.3);
  // Disable pulse animation when distance is 0
  const enablePulse = __enablePulse === true && pulserDistance !== 0;
  const pulserRef = useRef({});
  const [popoverAnchor, setPopoverAnchor] = useState(null);
  const pulserContainer = usePulserContainer(popoverAnchor);
  const pulserTargets = getAttachedElements(attachTo || target);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      ref: setPopoverAnchor,
      "aria-hidden": true,
      style: {
        display: 'none'
      }
    }), pulserContainer && /*#__PURE__*/createPortal(
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs(UITourPulserLayer, {
      className: "tour-pulser",
      zIndex: pulserZIndex,
      children: [/*#__PURE__*/_jsx("defs", {
        children: /*#__PURE__*/_jsx(UITourPulserBorderShadow, {
          borderColor: borderColor,
          borderShadowId: PULSER_BORDER_SHADOW_ID
        })
      }), enableOverlay &&
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(UITourPulserOverlay, {
        className: "tour-pulser-overlay",
        enablePulse: enablePulse,
        pulserDuration: pulserDuration,
        pulserOverlayColor: pulserOverlayColor,
        pulserRef: pulserRef
      }), pulserTargets.map((pulserTarget, index) =>
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(UITourPulserSpotlight, {
        className: "tour-pulser-border",
        borderColor: borderColor,
        borderSize: borderSize,
        borderShadowId: PULSER_BORDER_SHADOW_ID,
        enableBorder: enableBorder,
        pulserDistance: enablePulse ? pulserDistance : 0,
        pulserDuration: pulserDuration,
        pulserPadding: pulserPadding,
        pulserRadius: borderRadius,
        pulserRef: pulserRef,
        pulserTarget: pulserTarget
      }, index))]
    }), pulserContainer)]
  });
};
export default UITourPulserLegacy;